import React from 'react';
import withState from '~/hocs/withState';
import Head from 'next/head';

import { initStore } from '~/state/store';
import logEvent from '~/util/analytics';
import Layout from '~/components/Layout/Layout';
import Link from '~/components/Link/Link';
import NCAABTournamentLanding from '~/components/NCAABTournamentLanding/NCAABTournamentLanding';

import css from './ncaab_landing.scss';

class NCAABLanding extends React.Component {
  static async getInitialProps(props) {
    return {
      leagueSlug: props.leagueSlug,
    };
  }

  componentDidMount() {
    logEvent('page_view', {
      league: 'ncaab',
      page_type: 'ncaab_landing',
      page_name: 'ncaab_landing',
    });
  }

  render() {
    return (
      <Layout>
        <Head>
          <style dangerouslySetInnerHTML={{ __html: css.stylesheet }} />
        </Head>
        <Link route={'/ncaab/news'}>
          <a className={css.link}>
            <div className={css.linkContent}>
              <div className={css.arrow} />
              <div className={css.text}>BACK TO NCAAB</div>
            </div>
          </a>
        </Link>
        <NCAABTournamentLanding />
      </Layout>
    );
  }
}

NCAABLanding.displayName = 'NCAABLandingPage';

export default withState({ createStore: initStore })(NCAABLanding);
